import { FC } from 'react';
import { AchievementDetails } from 'containers/recognitions';

const RecognitionsAchievementDetailsPage: FC = () => {
  return <AchievementDetails />;
};

export default RecognitionsAchievementDetailsPage;
